//BOUTON "AFFICHER PLUS/MOINS"
export default function btnMore(btnTxt, btnContent) {
    if( btnTxt == 'Afficher plus' ){
        btnContent.innerHTML = 'Afficher moins';
    }
    else{
        btnContent.innerHTML = 'Afficher plus';
    }
}